import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Brand, Menu, MenuBottom, MenuMobile, PageTitle } from '../../utils/models/layout.interface';
import navigation from '../../utils/constants/layout/navigation.json';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from '../shared/components/navigation/navigation/navigation.component';
import { SharedModule } from '../shared/shared.module';
import { NotificationsBellComponent } from '../shared/components/navigation/notifications-bell/notifications-bell.component';
import { TopnavbarProfileComponent } from '../shared/components/navigation/topnavbar-profile/topnavbar-profile.component';
import { ModuleService } from '../service/module/module.service';

@Component({
  imports: [
    RouterOutlet,
    CommonModule,
    NavigationComponent,
    SharedModule,
    NotificationsBellComponent,
    TopnavbarProfileComponent
  ],
  styleUrls: ['./page.component.scss'],
  selector: 'app-page',
  templateUrl: './page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {
  private readonly moduleService = inject(ModuleService);
  private readonly router = inject(Router);

  readonly user: Menu = navigation.user;
  readonly brand: Brand = navigation.brand;
  readonly menuBottom: MenuBottom = navigation.bottom;

  readonly menus = computed<Menu[]>(() => this.moduleService.activeMenus());
  readonly pageTitles = computed<PageTitle[]>(() => this.moduleService.activePageTitles());
  readonly menuMobile = computed<MenuMobile>(() => this.moduleService.activeMenusMobile());

  readonly actualURL = signal<string>('');
  readonly hasMultipleLanguages = signal<boolean>(false);

  constructor() {
    this.router.events.subscribe({
      next: (res) => {
        if (res instanceof NavigationEnd) {
          this.actualURL.set(res.url);
        }
      },
    });
  }

  goHome(): void {
    this.router.navigate(['/conexoes']);
  }
}
